import { z } from "zod";

export const UpdateServiceFormSchema = z.object({
  vocationId: z.string(),

  name: z
    .string()
    .min(1, { message: "O nome é obrigatório." })
    .max(255, { message: "O nome não pode exceder 255 caracteres." }),

  value: z
    .number({
      required_error: "Valor é obrigatório",
      invalid_type_error: "Valor inválido",
    })
    .max(1000000, "O valor máximo permitido é R$ 1.000.000,00"),

  duration: z.string().min(1, { message: "Duração é obrigatório." }),

  salonId: z.string().min(1, { message: "Salon é obrigatório." }),

  observation: z.string().optional(),

  deleted_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type UpdateServiceData = z.infer<typeof UpdateServiceFormSchema>;
